module.exports = "<div ng-if=\"isHomeowners\">\r\n    <gw-endorsement-ho-select-changes\r\n            model=\"model.nextSteps\"\r\n            mode=\"mode\"\r\n            on-next=\"onNext\">\r\n    </gw-endorsement-ho-select-changes>\r\n</div>\r\n<div ng-if=\"isPA\">\r\n    <gw-endorsement-pa-select-changes\r\n            model=\"model.nextSteps\"\r\n            mode=\"mode\"\r\n            on-next=\"onNext\">\r\n    </gw-endorsement-pa-select-changes>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/endorsement/directives/templates/endorsement-select-changes.html
// module id = 1094
// module chunks = 0